import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../services/enumeration.service';
import {IExgTab} from 'exc-tab-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ReceiptCheckviewComponent} from './receipt-checkview.component';
import {ApplicationService} from '../services/application.service';

@Component({
  selector: 'app-receipt-collection-pager',
  templateUrl: './receipt-collection-checkview-viewer.component.html',
  styles: [
  ]
})
export class ReceiptCollectionCheckviewViewerComponent extends ExcTranslation implements OnInit, IExgTab {

  @ViewChild('VCCheckview', {read: ReceiptCheckviewComponent}) VCCheckview !: ReceiptCheckviewComponent;
  /************************/
  Data: any;
  tabinstance: any;
  private _dataObject: any;

  set dataObject(rcptID: any) {
    this._dataObject = this.appSvc.helperObj.clone({
      rcptID,
      reloadOpenerView: () => {}
    });
  }
  get dataObject(): any {
    return this._dataObject;
  }

  /************************/
  receiptTable = {
    selectKey: 'rcptID',
    state: 1,
    currentPage: 0,
    prefilter_type: 100,
    selectedRow: undefined as any,
    prefilter_DEL: 0,
    searchValue: '',
    uiFilter: [],
    uiSort: [],
    data: [] as any [],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 1} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 1, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    isLoading: true,
    pageChanged: (page: number) => {
      if (this.receiptTable.MetaInfo.dataPaging !== undefined) {
        this.receiptTable.MetaInfo.dataPaging.pageNo = page;
      }
      if (this.Data?.selectedRows && this.Data?.selectedRows.length > 0) {
        this.receiptTable.isLoading = true;
        this.receiptTable.paging = {
          pagingEndRow: page,
          pagingPage: page,
          pagingPageSize: 1,
          pagingStartRow: page,
          pagingTotalPages: this.Data.selectedRows.length,
          pagingTotalRows: this.Data.selectedRows.length
        };
        this.receiptTable.changeSelection(page);
      } else {
        this.loadReceiptListData();
      }
    },
    changeSelection: async (page: number): Promise<void> => {
      console.log(page, this.receiptTable.data[page - 1]);
      this.receiptTable.selectedRow = this.receiptTable.data[page - 1];
      this.dataObject = this.receiptTable.selectedRow[this.receiptTable.selectKey];

      await new Promise(f => setTimeout(f, 400));
      this.receiptTable.isLoading = false;
    },
    ready: () => {
      if (this.receiptTable.data.length === 0) {
        this.receiptTable.state = 2;
        this.receiptTable.selectedRow =  {};
      }  else {
        this.receiptTable.selectedRow = this.receiptTable.data[0];
        this.dataObject = this.receiptTable.data[0][this.receiptTable.selectKey];
        this.receiptTable.state = 0;
      }
    },
    loadData: (incomingData: any, paging: any) => {
      this.receiptTable.data = incomingData;
      this.receiptTable.paging = paging;
      //   {
      //   pagingEndRow: 1,
      //   pagingPage: 1,
      //   pagingPageSize: 1,
      //   pagingStartRow: 1,
      //   pagingTotalPages: length,
      //   pagingTotalRows: length
      // };
      this.receiptTable.ready();
      this.receiptTable.isLoading = false;
    },
    isFiltered: () => {
      return (this.receiptTable.uiFilter && JSON.stringify({}) !== JSON.stringify(this.receiptTable.MetaInfo.dataFilter));
    }
  };
  /************************/
  constructor(
    private excRest: ExcRestService,
    private appSvc: ApplicationService,
    private excSecurity: ExcSecurityService,
    public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    this.loadReceiptListData();
  }

  loadReceiptListData(): void {
    this.receiptTable.isLoading = true;
    if (this.Data) {
      if (this.Data?.selectedRows && this.Data?.selectedRows.length > 0) {
        const paging = {
          pagingEndRow: 1,
          pagingPage: 1,
          pagingPageSize: 1,
          pagingStartRow: 1,
          pagingTotalPages: this.Data.selectedRows.length,
          pagingTotalRows: this.Data.selectedRows.length
        };
        this.receiptTable.loadData(this.Data.selectedRows, paging);
      } else if (this.Data?.rcptID) {
        this.excRest.get(
          this.excRest.computeUrl('ReceiptR_List', this.Data),
          {MetaInfo: this.receiptTable.MetaInfo}
          ).subscribe( (response: any) => {
            if (response) {
              console.log(response.paging);
              this.receiptTable.loadData(response.data, response.paging);
            }
          }
        );
      }
    }
  }
}
